import { useTranslate as tolgeeUseTranslate } from "@tolgee/react";
import { useCallback } from "react";

import { TranslateParams, useTranslateResult } from "../types";

export const useTranslate = (): useTranslateResult => {
  const { t: tolgeeT, isLoading } = tolgeeUseTranslate();

  const t = useCallback(
    (keyName: string, defaultValue?: string, params?: TranslateParams) => {
      return tolgeeT(keyName, defaultValue, {
        ...(params || {}),
      });
    },
    [tolgeeT],
  );

  return {
    t,
    isLoading,
  };
};
